import request from '@/utils/request'
// 角色管理
const api = {
  Query(data) {
    return request({
      url: 'admin/role/query',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/role/delete',
      method: 'post',
      data
    })
  },
  Save(data) {
    return request({
      url: 'admin/role/createOrUpdate',
      method: 'post',
      data
    })
  },
  Get(id) {
    return request({
      url: '/admin/role/get',
      method: 'post',
      params: { id }
    })
  },
  getAll(data) {
    return request({
      url: 'admin/role/getAll',
      method: 'post',
      data
    })
  },
  Detail(id) {
    return request({
      url: 'admin/role/detail',
      method: 'post',
      params: { id }
    })
  }
}
export default api

